import request from '@/utils/request'

const getChangLongContinuousList_desktop = function(query) {
  return request({
    url: '/v1/cp168/apis/cpStatisticsByStatsType/nowDragon',
    method: 'get',
    params: query
  })
}

const getChangLongMissingList_desktop = function(query) {
  return request({
    url: '/v1/cp168/apis/cpStatisticsByStatsType/nowMissingDragon',
    method: 'get',
    params: query
  })
}

export {
  getChangLongContinuousList_desktop,
  getChangLongMissingList_desktop
}
